<script setup lang="ts">
  import { GlobalSearchProvider } from '@gat-ship/global-search'
  import {
    createStakeholderSearchFunctions,
    StakeholderSearchProvider
  } from '@gat-ship/stakeholder-search'
  import { SignalRProvider } from '@gat-ship/signalr'
  import { UserProvider } from '@gat-ship/user'
  import { SupportSessionProvider } from '@gat-ship/support-session'
  import { AppStateProvider } from '@gat-ship/app-state'
  import { FeatureFlagProvider } from '@gat-ship/feature-flag'
  import { GlobalSettingsProvider } from '@gat-ship/global-settings'
  import AppInitialization from './AppInitialization.vue'
  import { GsCloudBackendProvider } from '@gat-ship/http-client'
  import { SupportSessionAssignedProvider } from '@gat-ship/support'
  import {
    createModalStack,
    ModalStackHost,
    ModalStackTabs,
    provideModalStack
  } from '@gat-ship/vue-components'
  import { registerAppModals } from './modal-stack/register-app-modals'
  import { useModalsUrlSync } from './modal-stack/useModalsUrlSync'

  // Central modal host (central-modal-host plan, Phases 1–2). One ordered stack
  // owns open-state, stacking order, and z-index; the 6 modals render through
  // <ModalStackHost> from the registry, and the codec sync makes the single
  // ordered `?modals=` query param the only reader/writer of the stack (with a
  // one-time redirect from the legacy per-feature params).
  registerAppModals()
  const modalStack = createModalStack()
  provideModalStack(modalStack)
  useModalsUrlSync(modalStack)

  const stakeholderSearchFunctions =
    createStakeholderSearchFunctions(modalStack)
</script>
<template>
  <GsCloudBackendProvider internal-is-global>
    <SignalRProvider>
      <UserProvider>
        <SupportSessionProvider>
          <AppStateProvider>
            <FeatureFlagProvider>
              <GlobalSettingsProvider>
                <GlobalSearchProvider
                  :search-functions="stakeholderSearchFunctions"
                >
                  <StakeholderSearchProvider>
                    <AppInitialization>
                      <SupportSessionAssignedProvider>
                        <ModalStackHost />
                        <ModalStackTabs />
                        <slot />
                      </SupportSessionAssignedProvider>
                    </AppInitialization>
                  </StakeholderSearchProvider>
                </GlobalSearchProvider>
              </GlobalSettingsProvider>
            </FeatureFlagProvider>
          </AppStateProvider>
        </SupportSessionProvider>
      </UserProvider>
    </SignalRProvider>
  </GsCloudBackendProvider>
</template>
